import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { format } from "date-fns";

import { defaultHotelFormValue } from "../lib/hotel-search-defaults";
import { IHotelsSearchSchema } from "../types/hotel-search-type";

type HotelFormState = IHotelsSearchSchema | null;

function toSerializableDate(value: Date | string): string {
  if (typeof value === "string") {
    return value;
  }

  if (Number.isNaN(value.getTime())) {
    return "";
  }

  return format(value, "yyyy-MM-dd");
}

function toSerializableHotelForm(
  value: IHotelsSearchSchema,
): IHotelsSearchSchema {
  return {
    ...value,
    date: {
      ...value.date,
      from: toSerializableDate(value.date.from),
      to: toSerializableDate(value.date.to),
    },
  };
}

const initialState: HotelFormState = toSerializableHotelForm(
  defaultHotelFormValue,
);

const hotelFormSlice = createSlice({
  name: "hotelSearchForm",
  initialState,
  reducers: {
    setHotelSearch(state, action: PayloadAction<IHotelsSearchSchema>) {
      return toSerializableHotelForm(action.payload);
    },
    resetHotelSearch() {
      return toSerializableHotelForm(defaultHotelFormValue);
    },
  },
});

export const { setHotelSearch, resetHotelSearch } = hotelFormSlice.actions;
export default hotelFormSlice;
